module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAAAXNSR0IArs4c6QAAAG1JREFUGBmFkd0NwCAIhNVd2tnYSFezHYYKCclxMdYX+XJ34E8phzXGeFBuCEucyKp6ISfzEm8UuXYzj2OOkJt5HHOEWxSR3u0WNl8TkeM5LVxrfc3nxzDAjszbhr13xRBzerrVMX0CBn9rvvwH/Acx5OqRG4QAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-tracks-count.png
// module id = 1079
// module chunks = 0